<template>
  <div>
    <pdf-wiki ref="pdfWiki" />
    <!-- <Loading :visible="true"/> -->
  </div>
  
</template>

<script>
import PDFWiki from '@components/pdf/PDFWiki' ; 
import Loading from '@common/loading.vue'
export default {
  name: 'PdfDowload',
  components: {
    'pdf-wiki' : PDFWiki, 
    Loading
  },
  data() {
    return {
      loading: true
    }
  },
  async mounted() {
    const {processId, protocolId} = this.$route.query;
    await this.$refs.pdfWiki.printReady({ processId , keyOfProtocol: protocolId }) ; 
    window.close();
  }
}
</script>

<style>
</style>